module.exports = __webpack_public_path__ + "img/list4.1c7bfc31.png";